import { SaveNewNPSResponse } from '../../types'
import { SaveNPSData } from './SaveNPSMapper.types'

export class SaveNpsMapper {
  static toPersistence(data: SaveNPSData) {
    const isModeAttendedAppointment = data?.details?.length > 0

    const dataToPersistence = {
      idAtendimento: data?.attendanceId,
      avaliaProfissional: !!data?.professionalRating,
      medico: {
        avaliacao: data?.professionalRating,
        comentario: data?.professionalCommentary,
        detalhes: [],
      },
      chamada: {
        avaliacao: data?.rating,
        comentario: data?.commentary,
        detalhes: data?.details?.map(details => details.value),
      },
      atendimentoSemChamada: {
        comentario: data?.commentary,
        motivo: data?.reason,
      },
    }

    if (isModeAttendedAppointment) {
      delete dataToPersistence.atendimentoSemChamada
    } else {
      delete dataToPersistence.medico
      delete dataToPersistence.chamada
    }

    return dataToPersistence
  }

  static toDomain(data: SaveNewNPSResponse) {
    return {
      professionalId: data?.idProfissional,
      professionalName: data?.nomeProfissional,
      professionalPhoto: data?.fotoProfissional,
      councilType: data?.tipoConselho,
      specialtyId: data?.idEspecialidade,
      specialtyName: data?.nomeEspecialidade,
      fitInAttendance: data?.encaixe,
      attendanceType: data?.modoAtendimento,
      showProfessionalRecommendation: !data?.naoExibirRecomendacaoProfissional,
    }
  }
}
